/** Card/list label: "Name (emp#)" when a number exists, otherwise just the name (no empty "()"). */
export function formatEmployeeNameWithNo(name, employeeNo) {
  const n = name || 'Unknown';
  const no = employeeNo != null && String(employeeNo).trim();
  return no ? `${n} (${no})` : n;
}
